import { render, staticRenderFns } from "./ModalNuevoProfesional.vue?vue&type=template&id=0814bc86&scoped=true&"
import script from "./ModalNuevoProfesional.vue?vue&type=script&lang=js&"
export * from "./ModalNuevoProfesional.vue?vue&type=script&lang=js&"
import style0 from "./ModalNuevoProfesional.vue?vue&type=style&index=0&id=0814bc86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0814bc86",
  null
  
)

export default component.exports